<template>
  <div v-bind:class="success_submit ? 'container container_flex ' + language_class : 'container ' + language_class ">
    <div class="header">
      <div class="content">
        <div class="logo">
          <img :src="image">
        </div>
      </div>
    </div>

    <div v-bind:class="success_submit ? 'middle_body middle_body_flex' : 'middle_body' " v-if="success_submit">
      <div class="middle_content">
        <div class="pannel_header">
          <div class="title">
            <h1>{{ lang_text.thank_title }}</h1>
          </div>
          <div class="pannel_body">
            <div class="text">
              <p  style="text-align: center; margin-bottom: 30px;" v-html="lang_text.thank_text1"></p>
            </div>

            <div class="ot-btns">
              <button class="ot-submit" type="button" id="NuFdAuwHIo79" aria-label="" @click="close_window()"> {{lang_text.thank_text2}}</button>
            </div>            
          </div>          
        </div>    
      </div>    
    </div>
    <div v-bind:class="success_submit ? 'middle_body middle_body_flex' : 'middle_body' " v-else>
      <div class="middle_content">
        <div class="pannel_header">
          <ul class="head_tips ">
              <li  @click="selectEnglish()" v-bind:class="language == 'en' ? 'active' : ''">English</li>
              <li  @click="selectChinese()" v-bind:class="(language == 'zh') ? 'active' : ''">中文</li>
          </ul>
          <div class="title">
            <h1>{{ title }}</h1>
          </div>
          <div class="pannel_body">
          </div>

        </div>
        <div class="pannel_body">
          <div class="text" v-if="lang_text.text1">
            <p v-html="lang_text.text1"></p>
          </div>
          <div class="text" v-if="lang_text.text2">
            <p v-html="lang_text.text2"></p>
          </div>
          <div class="purpose_desc">
              <div v-bind:class="'otwf-chkbox ot-el ot-pur  ' + (!purposes[index]['checked'] ? warningUI : '')" v-bind:key="'input-key-' + (1 + index)"  v-for="(purpose, index) in  purposes" >
                <input type="checkbox"  v-bind:id="'esJCOXeCeS56-' + (1 + index)" v-bind:name="'name-key-' + (1 + index) " value="true" v-model="purpose.checked" aria-required="false" aria-checked="false"> 
                <label v-bind:for="'esJCOXeCeS56-' + (1 + index)">
                  <span class="ot-label" v-html='"<span class=\"ot-asterisk ot-n\">*</span>" + purpose.description'></span>
                </label>
                <span class="ot-error"><span class="ot-error-prefix">!</span>{{lang_text.warning_purpose}}</span>
              </div>            
          </div>
          <div class="input_boxs">
            <div v-bind:class="'ot-txt ot-el ot-de  ' + ((!phone || !phone_validate) ? warningUI : '')">
              <label for="xOzFEXIwgn91" class="ot-label">{{lang_text.label_phone}}</label>
              <span class="ot-asterisk">*</span> 
              <input type="text" autocomplete="off" id="xOzFEXIwgn93" required="" name="phone" aria-label="电话号码" aria-required="true" v-model="phone">
              <span class="ot-error"><span class="ot-error-prefix">!</span>{{ (phone && !phone_validate) ? lang_text.warning_phone_format : lang_text.warning_phone}}</span>
            </div>

            <div v-bind:class="'ot-txt ot-el ot-de  ' + ((email && !email_validate) ? warningUI : '')">
              <label for="xOzFEXIwgn93" class="ot-label">{{lang_text.label_email}}</label>
              <input type="text" autocomplete="off" id="xOzFEXIwgn92" required="" name="email" v-model="email" aria-label="电子邮件" aria-required="true">
              <span class="ot-error"><span class="ot-error-prefix">!</span>{{lang_text.warning_email}}</span>
            </div>
          </div>
           <div class="ot-btns">
            <button class="ot-submit" type="button" id="NuFdAuwHIo79" aria-label="提交" @click="consent_submit()" :disabled="isDisabled"> {{submiting ? lang_text.label_submiting : lang_text.label_submit}}</button>
           </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <ul>
            <li>© Agilent Technologies, Inc. 2024</li>
            <li><a v-bind:href="footerConfig.footer_text1_href ? footerConfig.footer_text1_href : '#'" target="_blank">{{lang_text.footer_text1}}</a></li>
            <li><a v-bind:href="footerConfig.footer_text2_href ? footerConfig.footer_text2_href : '#'" target="_blank">{{lang_text.footer_text2}}</a></li>
            <li><a v-bind:href="footerConfig.footer_text3_href ? footerConfig.footer_text3_href : '#'" target="_blank">{{lang_text.footer_text3}}</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import image from "../assets/logo.svg"

export default {
  name: '数据传输同意书',
  props: {
    msg: String
  },
  data() {
    return {
      title: '数据传输同意书',
      image: image,
      source: '',
      lang_text: {
        label_phone: '电话号码',
        label_email: '电子邮件',
        label_submit: '提交',
        label_submiting: '提交中...',
        warning_purpose: '同意请勾选',
        warning_phone: '请填写手机号',
        warning_phone_format: '请检查手机号格式',
        warning_email: '请检查邮件格式.',

        text1: 'Agilent operates globally and transfers your inquiries and associated contact information within our global group of Agilent affiliates for processing. Agilent has adopted technical and organizational security measures to protect personal data in accordance with applicable law. Agilent is asking for your consent to comply with China’s privacy law. If you have questions about why we are asking for your consent, please visit Agilent\'s Privacy Program Overview.',
        text2: 'Note: Your privacy is important to us. If you update your privacy settings (such as deleting browser cookies) or if you provide different contact information, we may ask for your consent again the next time you interact with us.​',
        footer_text1: 'Privacy Statement​',
        footer_text2: 'Terms of Use',
        footer_text3: 'Contact Us',
        thank_title: 'Thank You!',
        thank_text1: 'The form has been submitted successfully.',
        thank_text2: 'Agilent.com Home',
      },
      host: process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : '',
      appId: process.env.VUE_APP_ID,
      language: 'zh',
      textConfig: {},
      footerConfig: {},
      close_url: 'https://stgwww.agilent.com',
      purposes: [],
      phone: '',
      phone_validate: false,
      email: '',
      email_validate: false,
      warningUI: '',
      language_class: '',
      submiting: false,
      success_submit: false,
      // success_submit: true,
    };
  },
  computed: {
      isDisabled() {
        // you can  check your form is filled or not here.
        return this.submiting == true
      },
  },    
  methods: {
    selectEnglish (){
      this.language = 'en';
      this.language_class = 'language-en';
      this.title = 'Data Transfer Consent'
      document.title = this.title
      this.lang_text.label_phone = 'Telephone Number'
      this.lang_text.label_email = 'Email'
      this.lang_text.label_submit = 'SUBMIT'
      this.lang_text.label_submiting = 'SUBMITING...'
      this.lang_text.warning_purpose = 'Consent is required for registration'
      this.lang_text.warning_phone = 'Telephone Number is required'
      this.lang_text.warning_phone_format = 'Telephone Number is not validated'

      this.lang_text.warning_email = 'Please check Email format.'

      this.lang_text.text1 = 'Agilent operates globally and transfers your inquiries and associated contact information within our global group of Agilent affiliates for processing. Agilent has adopted technical and organizational security measures to protect personal data in accordance with applicable law. Agilent is asking for your consent to comply with China’s privacy law. If you have questions about why we are asking for your consent, please visit Agilent\'s Privacy Program Overview.'
      this.lang_text.text2 = 'Note: Your privacy is important to us. If you update your privacy settings (such as deleting browser cookies) or if you provide different contact information, we may ask for your consent again the next time you interact with us.​'
      this.lang_text.footer_text1 = 'Privacy Statement​'
      this.lang_text.footer_text2 = 'Terms of Use'
      this.lang_text.footer_text3 = 'Contact Us'
      this.lang_text.thank_title = 'Thank You!'
      this.lang_text.thank_text1 = 'The form has been submitted successfully.'
      this.lang_text.thank_text2 = 'Agilent.com Home'
      this.warningUI = ''
      this.getPurpose('en');
      this.getAppInfo();
    },
    selectChinese(){
      this.language = 'zh';
      this.language_class = '';
      this.title = '数据传输同意书'
      document.title = this.title
      this.lang_text.label_phone = '电话号码'
      this.lang_text.label_email = '电子邮件'
      this.lang_text.label_submit = '提交'
      this.lang_text.label_submiting = '提交中...'
      this.lang_text.warning_purpose = '同意请勾选'
      this.lang_text.warning_phone = '请填写手机号'
      this.lang_text.warning_phone_format = '请检查手机号格式'
      this.lang_text.warning_email = '请检查邮件格式'
      this.lang_text.text1 = '安捷伦是一家跨国公司，为了向您提供产品和服务，安捷伦将您的要求和相关联系信息传递到全球安捷伦集团 相关团队进行处理。安捷伦根据适用法律，采取了技术和组织安全措施保护个人信息。此同意书为遵守中国大 陆隐私法规要求所需。如果您对此有疑问，请访问 <a href="#">安捷伦隐私计划</a>。'
      this.lang_text.text2 = '注意：保护您的隐私对我们很重要。如果您调整了隐私设置（比如删除浏览器cookie）或者您提供了不同的联系信息，我们可能在您下次与我们互动时再次征求您的同意。'
      this.lang_text.footer_text1 = '隐私权声明'
      this.lang_text.footer_text2 = '使用条款'
      this.lang_text.footer_text3 = '联系我们'
      this.lang_text.thank_title = '谢谢 !'
      this.lang_text.thank_text1 = '表格已提交。'
      this.lang_text.thank_text2 = '安捷伦公司网站'
      this.warningUI = ''

      this.getPurpose('zh');
      this.getAppInfo();

    },
    getAppInfo (){
      axios.post(this.host + '/onetrust/api/v1/app/webform-info', {
      }).then( (response) => {
        // console.log(response.data);
        if (response.data.data) {
          for (var index in response.data.data){
            if (index == this.language) {
              // console.log('set ' + this.language)
              this.textConfig = response.data.data[index];
              // console.log(response.data.data[index]); 
              this.lang_text.text1 = response.data.data[index]['text1']
              this.lang_text.text2 = response.data.data[index]['text2']
              this.lang_text.text2 = response.data.data[index]['text2']
              this.close_url = response.data.data[index]['close_url'] || this.close_url;
              this.footerConfig = {
                footer_text1_href: response.data.data[index]['footer_text1_href'],
                footer_text2_href: response.data.data[index]['footer_text2_href'],
                footer_text3_href: response.data.data[index]['footer_text3_href'],
              }
              break;
            }
          }
        }
      }).catch((error) => {
        console.log(error);
      });		
    },  
    descTranform (desciption){
      const regex = /\[([\s\S]*?)\]\(([\s\S]*?)\)/
      let a = true;
      while(a){
        let match = regex.exec(desciption);
        if (match) {
          const key_word = match[1];
          const link = match[2];
          const anchor = `<a href="${link}" target="_blank">${key_word}</a>`
          desciption = desciption.replace(regex, anchor);
        }else{
          break;
        }
      }
      return desciption
    },
    phoneReady(phone){
      phone = phone || ''
      phone = phone.trim()
      return /^(\+86)?1\d{10}$/.test(phone)
    },

    emailReady(email){
      const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
      return reg.test(email);
    },
    close_window(){
      // window.close();
      // window.location.href="https://stgwww.agilent.com/";
      window.location.href= this.close_url;
      // window.close();
      // window.close('','_parent','');
    },
    getRequest(value) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(value);
    },
    getPurpose (language){
      axios.post(this.host + '/onetrust/api/v1/wechat/purpose-query', {
       "app_id": this.appId,
       "language": language || "zh"
      }).then( (response) => {
       // console.log(response.data);
       if (response.data.data) {
        this.purposes = []
        for (var purpose of response.data.data){
         this.purposes.push({
            id: purpose.id,
            description: this.descTranform(purpose.language.description),
            checked: false,
          })
         }
       }
      }).catch( (error) => {
        console.log(error);
        if( error.response ){      
          if(error.response.data){
            alert(error.response.data['message'])
          }
        }else{
          alert(error.toString());
        }
      });		
    },
    // async consent_submit () {
    consent_submit () {
      console.log('calling consent_submit')
      if (this.submiting) {
        console.log('ignore duplidate consent_submit')
        return
      }else{
        console.log('set consent_submit true')
        this.submiting = true
        // await new Promise(resolve => setTimeout(resolve, 200));
      }
      
      if (!this.phone) {
        this.warningUI = 'ot-err-show'
        this.submiting = false
        return
      }else{
        if (!this.phone_validate) {
          this.warningUI = 'ot-err-show'
          // alert('手机号格式不正确,请修改')
          this.submiting = false
          return          
        }
      }
      for (let purpose of this.purposes) {
        if (purpose.checked == false) {
          this.warningUI = 'ot-err-show'
          this.submiting = false
          return          
        }
      }
      if (this.email) {
        if (!this.email_validate) {
          this.warningUI = 'ot-err-show'
          this.submiting = false
          return          
        }
      }

      // console.log(this.phone)
      // console.log(this.email)
      // console.log(this.purposes)

      axios.post(this.host + '/onetrust/api/v1/wechat/access-token', {
        "identifier": this.phone,
        "app_id": this.appId 
      })
      .then( (response) => {
        // console.log(response.data.data.token);
        const token = response.data.data.token;

        let payload = {
          "phone": this.phone,
          "email": this.email,
          "purposes": [
          ],
          "page_url": window.location.href,
          "user_fullname": "",
        }
        if (this.source) {
          payload['source'] = `standalone form[${this.source}]`;
        }
        // console.log(payload)
        for (let purpose of this.purposes) {
          payload.purposes.push({
            id: purpose.id,
            transaction_type: "CONFIRMED",
          })
        }

        axios.post(this.host + '/onetrust/api/v1/wechat/consentreceipts', payload, {
          headers: {
            'content-type': 'application/json',
            'Authorization': 'Bearer ' + token,
          }
        })
        .then( (response) => {
          // console.log(response.data);
          this.success_submit = true;
          if (response.data.data) {
            // console.log(response.data.data)
            // alert('suceess');
            this.success_submit = true;
          }
          this.submiting = false
        })
        .catch( (error) => {
          console.log(error);
          if( error.response ){      
            if(error.response.data){
              alert(error.response.data['message'])
            }
          }else{
            alert(error.toString());
          }
          this.submiting = false
        });           

      })
      .catch( (error) => {
        console.log(error);
        if( error.response ){      
          if(error.response.data){
            alert(error.response.data['message'])
          }
        }else{
          alert(error.toString());
        }
        this.submiting = false
      });         
      // this.submiting = false
    }
  },
  watch: {
    phone: {
      handler: function (val, oldVal) {
        console.log('changed', val, oldVal);
        if (this.phoneReady(val)) {
          this.phone_validate = true;
        }else{
          this.phone_validate = false;
        }
      },
      deep: true
    },
    email: {
      handler: function (val, oldVal) {
        console.log('changed', val, oldVal);
        if (this.emailReady(val)) {
          this.email_validate = true;
        }else{
          this.email_validate = false;
        }
      },
      deep: true
    },

  }, 
  
  mounted(){
    document.title = this.title
    // this.getAppInfo()
    // this.getPurpose(this.language)
    this.source = this.getRequest('source')
    console.log("source: ", this.getRequest('source'))
    console.log(process.env.VUE_APP_ID)
    console.log('VUE_APP_HOST:', process.env.VUE_APP_HOST)
    this.selectChinese()
  }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
*/</style>
